import { browserTracingIntegration, init } from '@sentry/browser';

export function sentryInit() {
  init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.2,
    release: process.env.REACT_APP_VERSION || 'no data',
  });
}
